import type { UnifiedProductSummary } from '@noths/polaris-client-unified-product-service';
import type { ProductCarouselItem } from '@noths/polaris-design-system-candidate-components';

import { transformUnifiedProductToProduct } from 'src/utils/unifiedProductToProduct';

/**
 * One carousel item is one card's props: the product itself plus the flags that
 * are presentation rather than properties of the product.
 */
export const transformUnifiedProductToProductCarouselItem = (
  product: UnifiedProductSummary,
  { priority, promoteAsSale }: { priority: boolean; promoteAsSale: boolean },
): ProductCarouselItem => ({
  isNew: product.isNew,
  priority,
  product: transformUnifiedProductToProduct(product),
  /* From the site-wide Contentstack switch, not `product.onSale`. Nothing UPS carries
     distinguishes a sale from an offer, so presenting a discount as either is a
     decision about the whole site rather than about this product. */
  promoteAsSale,
});
